// @flow
import ButtonGoBack from '@shared/Navigation/ButtonGoBack/components/ButtonGoBack';

export default ButtonGoBack;
